import { carouselTopics } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">焦点专题</h2>
            <p className="text-sm text-foreground-500 mt-2">深度探索电影世界的精彩专题内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselTopics.slice(0, 2).map((topic, i) => (
            <div key={topic.id} className={`bg-background-50 rounded-xl overflow-hidden group cursor-pointer border border-background-200/60 ${i === 0 ? 'lg:col-span-2' : ''}`}>
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img src={topic.imageUrl} alt={topic.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
              </div>
              <div className="p-5 md:p-6">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{topic.tag}</span>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mt-3">{topic.title}</h3>
                <p className="text-sm text-foreground-500 mt-1">{topic.subtitle}</p>
                <p className="text-sm text-foreground-400 mt-3 leading-relaxed line-clamp-3">{topic.desc}</p>
              </div>
            </div>
          ))}
          {carouselTopics.slice(2).map((topic) => (
            <div key={topic.id} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer border border-background-200/60">
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img src={topic.imageUrl} alt={topic.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
              </div>
              <div className="p-5">
                <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">{topic.tag}</span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mt-2">{topic.title}</h3>
                <p className="text-xs text-foreground-500 mt-1">{topic.subtitle}</p>
                <p className="text-xs text-foreground-400 mt-2 leading-relaxed line-clamp-2">{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}